import { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store/types/RootState';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getPartiesList, getPartiesListSuccess, setPartiesListLoading } from '@/features/parties/store/partiesSlice';
import HttpService from '@/services/HttpService/HttpService';

function* getPartiesListSaga({ payload: claimSetId }: PayloadAction<number>) {
  try {
    if (!claimSetId) return;

    yield put(setPartiesListLoading(true));

    const savedFilters = yield select((state: RootState) => state.parties.savedFiltersForSending);
    const requestUrl = `/ExaminerParty/claimset/${claimSetId}/parties`;

    const { data } = yield call(HttpService.post, requestUrl, savedFilters?.filters ?? [], {});

    yield call(
      HttpService.get,
      'v2/definitions/render?nameFilter=Party&includeOnlyFilter=PartyType',
      {},
      {
        baseURL: import.meta.env.VITE_API_URL_EDS,
      },
    );

    yield put(getPartiesListSuccess(data));
  } catch (error) {
    console.error(error);
  } finally {
    yield put(setPartiesListLoading(false));
  }
}

export function* partiesWatcher() {
  yield takeLatest(getPartiesList.type, getPartiesListSaga);
}
